import React, { useState } from 'react'
import { Card, Button } from 'react-bootstrap'
import ScaleComponent from './five-star'
import Feedback from './feedback'
import { get } from 'lodash'
import useUserFacilitatorRatingMutation from '../../../hooks/use-user-facilitator-rating-mutation'
import SpinnerButton from '../../common/spinner-button'
import useToasts from '../../../hooks/use-toasts'
import Name from '../../user/full-name'

const FacilitatorPrompt = ({
    userRating = {},
    userId,
}) => {
    const [ feedback, setFeedback ] = useState()
    const [ rating, setRating ] = useState(userRating.rating)
    const {
        success: toastSuccess,
        error: toastError,
    } = useToasts({
        successMessage: 'Thank you!',
        errorMessage: 'Error submitting feedback.'
    })
    const {
        updateFacilitatorRating,
        isUpdating,
    } = useUserFacilitatorRatingMutation({
        userId,
        ratingId: userRating.id,
        feedback,
        rating,
        onSuccess: toastSuccess,
        onError: toastError,
    })

    const renderFeedback = () => {
        if (!rating) {
            return null
        }
        return (
            <React.Fragment>
                <Feedback
                    value={feedback}
                    onChange={setFeedback}
                />
                <SpinnerButton
                    onClick={() => updateFacilitatorRating()}
                    busy={isUpdating}
                >
                    Submit Feedback
                </SpinnerButton>
            </React.Fragment>
        )
    }

    const facilitator = get(userRating, 'facilitatorToRate', '')

    return (
        <React.Fragment>
            <div>How was <Name user={facilitator} />?</div>
            <div><ScaleComponent value={rating} onChange={setRating} /></div>
            {renderFeedback()}
        </React.Fragment>
    )
}

export default FacilitatorPrompt